import Vue from 'vue'
import Vant from 'vant'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n/index'
import 'vant/lib/index.css'
import { ConstantsPlugin,loadData } from './plugins/const'
import axios from '@/plugins/axios'
import { Lazyload } from 'vant'

Vue.config.productionTip = false
Vue.use(Vant)
Vue.use(ConstantsPlugin)
Vue.use(Lazyload)

const beginer = async function(){
  try{
    const ssid = sessionStorage.getItem('ss_id')
    if(ssid === null){
      const res = await axios.get('/startSession')

      sessionStorage.setItem('ss_id', res.sessionId)
      sessionStorage.setItem('key', res.key)
    }
    loadData()
    new Vue({
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }catch(err){
    alert('System Error')
  }
}

beginer()

